"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.list.title': 'Pytania',
    'question.list.empty': 'Nie znaleziono pytań',
};
